import { moveToFulfilled, moveToPending } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { DeleteTeamsMeetingFulfilledAction } from '../../domains/deleteTeamsMeeting/actions.types';
import {
  TeamsMeetingsByOrganizerFulfilledAction,
  TeamsMeetingsByOrganizerPendingAction,
} from '../../domains/teamsMeetingsByOrganizer/actions.types';

import { TeamsMeetingsByOrganizer, TeamsMeetingsByOrganizers } from './types';

const initialState: TeamsMeetingsByOrganizers = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type TeamsMeetingsByOrganizerAction =
  | TeamsMeetingsByOrganizerFulfilledAction
  | TeamsMeetingsByOrganizerPendingAction
  | DeleteTeamsMeetingFulfilledAction;

const removeTeamsMeetingId = (state: TeamsMeetingsByOrganizers, teamsMeetingId: string) => {
  const teamsMeetingsByOrganizers = state.fulfilled.byId;

  const filteredTeamsMeetingsByOrganizers = Object.keys(teamsMeetingsByOrganizers).reduce(
    (filtered: TeamsMeetingsByOrganizers['fulfilled']['byId'], id: TeamsMeetingsByOrganizer['id']) => {
      const currentTeamsMeetingIds = state.fulfilled.byId[id].teamsMeetingIds;
      const teamsMeetingIds = currentTeamsMeetingIds.filter((id) => id !== teamsMeetingId);

      return {
        ...filtered,
        [id]: { ...teamsMeetingsByOrganizers[id], teamsMeetingIds },
      };
    },
    {}
  );

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      byId: filteredTeamsMeetingsByOrganizers,
    },
  };
};

const reducer: Reducer<TeamsMeetingsByOrganizers, TeamsMeetingsByOrganizerAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TEAMS_MEETINGS_BY_ORGANIZER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.teamsMeetingsByOrganizers);
    case 'TEAMS_MEETINGS_BY_ORGANIZER.LOAD_PENDING':
      return moveToPending(state, [action.payload.teamsMeetingsByOrganizersKey]);
    case 'DELETE_TEAMS_MEETING.FULFILLED':
      return removeTeamsMeetingId(state, action.payload.id);
    default:
      return state;
  }
};

export default reducer;
